import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import ProductShipping from 'components/ProductPageV2/ProductTab/ProductShipping/ProductShipping';
import ProductHelp from 'components/ProductPageV2/ProductTab/ProductHelp/ProductHelp';
import { HELP_TAB_ID, SHIPPING_TAB_ID } from 'settings/productV2';

import styles from './Tabs.module.scss';

export default function Tabs(): JSX.Element {
  const { t } = useTranslation();
  const sections = useMemo(
    () => [
      {
        id: SHIPPING_TAB_ID,
        label: t('LABEL_TAB_SHIPPING'),
        content: <ProductShipping />,
      },
      {
        id: HELP_TAB_ID,
        label: t('LABEL_TAB_HELP'),
        content: <ProductHelp />,
      },
    ],
    []
  );

  return (
    <div className={styles.container}>
      {sections.map(({ id, label, content }) => (
        <Accordion
          key={id}
          square
          elevation={0}
          classes={{
            root: styles.accordion,
            expanded: styles.accordionExpanded,
          }}
        >
          <AccordionSummary
            classes={{
              root: styles.summary,
              expanded: styles.summaryExpanded,
              content: styles.summaryContent,
              expandIcon: styles.expandIcon,
            }}
            expandIcon={<ExpandMoreIcon />}
          >
            {label}
          </AccordionSummary>
          <AccordionDetails className={styles.details}>
            {content}
          </AccordionDetails>
        </Accordion>
      ))}
    </div>
  );
}
